module.exports = __webpack_public_path__ + "img/description.54a94f4b.png";